import React from 'react';

import { SVGComponentProps } from './svg.types';

const InsertLeft = ({ fill = 'currentColor', size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 2H7.5H12.5H13V2.5V11.5V12H12.5H7.5H7V11.5V2.5V2ZM8 3V5H12V3H8ZM8 8V6H12V8H8ZM8 9V11H12V9H8Z"
        fill={fill}
      />
      <g clipPath="url(#clip0_2528:16489)">
        <path
          d="M4.57192 3.5715H3.45763C3.4428 3.5705 3.42885 3.56416 3.41834 3.55365C3.40783 3.54314 3.40149 3.52918 3.40049 3.51436V2.42864C3.40468 2.37371 3.39742 2.31849 3.37918 2.2665C3.36095 2.21451 3.33212 2.16687 3.29452 2.12659C3.25693 2.08631 3.21139 2.05427 3.16077 2.03249C3.11016 2.01071 3.05558 1.99968 3.00049 2.00007C2.94392 1.99903 2.88772 2.0094 2.83525 2.03056C2.78278 2.05173 2.73512 2.08326 2.69511 2.12327C2.6551 2.16327 2.62357 2.21094 2.60241 2.26341C2.58124 2.31588 2.57087 2.37207 2.57191 2.42864V3.54293C2.57091 3.55775 2.56457 3.57171 2.55406 3.58222C2.54356 3.59273 2.5296 3.59907 2.51477 3.60007H1.42906C1.37362 3.59343 1.31741 3.59897 1.26434 3.61631C1.21127 3.63365 1.16262 3.66237 1.12181 3.70047C1.08099 3.73856 1.04899 3.78511 1.02803 3.83686C1.00708 3.88861 0.997676 3.94431 1.00049 4.00007C1.00324 4.11287 1.04928 4.22029 1.12906 4.30007C1.20884 4.37985 1.31626 4.42589 1.42906 4.42864H2.54334C2.55817 4.42965 2.57213 4.43599 2.58263 4.4465C2.59314 4.457 2.59948 4.47096 2.60049 4.48579V5.60007C2.59911 5.65298 2.60852 5.7056 2.62813 5.75476C2.64775 5.80391 2.67716 5.84855 2.71458 5.88597C2.752 5.9234 2.79665 5.95281 2.8458 5.97242C2.89495 5.99204 2.94758 6.00145 3.00049 6.00007C3.11328 5.99732 3.2207 5.95128 3.30048 5.8715C3.38027 5.79171 3.4263 5.6843 3.42906 5.5715V4.45721C3.43006 4.44239 3.4364 4.42843 3.44691 4.41792C3.45742 4.40742 3.47138 4.40107 3.4862 4.40007H4.60049C4.70589 4.39788 4.80636 4.35504 4.88091 4.28049C4.95545 4.20595 4.9983 4.10547 5.00049 4.00007C5.00515 3.94261 4.99726 3.88482 4.97737 3.83071C4.95748 3.77659 4.92607 3.72745 4.8853 3.68669C4.84454 3.64592 4.79539 3.6145 4.74128 3.59461C4.68717 3.57473 4.62938 3.56684 4.57192 3.5715Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2528:16489">
          <rect width="4" height="4" fill="white" transform="translate(1 2)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InsertLeft;
